var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinterest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3674_13205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 24C19.1274 24 24.5 18.6274 24.5 12C24.5 5.37258 19.1274 0 12.5 0C5.87258 0 0.5 5.37258 0.5 12C0.5 18.6274 5.87258 24 12.5 24Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3674_13205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 24C19.1274 24 24.5 18.6274 24.5 12C24.5 5.37258 19.1274 0 12.5 0C5.87258 0 0.5 5.37258 0.5 12C0.5 18.6274 5.87258 24 12.5 24Z",
    fill: "#E40118"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.028 4.6001C16.7813 4.6001 20.1999 7.18196 20.1999 11.1384C20.1999 14.8559 18.2993 18.9797 14.0679 18.9797C13.0639 18.9797 11.7968 18.4777 11.3068 17.5453C10.3983 21.1432 10.4701 21.6811 8.46195 24.4303C8.25475 24.506 8.3225 24.522 8.18701 24.3706C8.1153 23.6175 8.00771 22.8764 8.00771 22.1234C8.00771 19.6849 9.13132 16.1588 9.68115 13.7921C9.38232 13.1825 9.29867 12.4413 9.29867 11.772C9.29867 8.58447 13.04 8.10635 13.04 10.744C13.04 12.2979 11.9881 13.7562 11.9881 15.2623C11.9881 16.2903 12.8368 17.0075 13.8289 17.0075C16.5781 17.0075 17.4268 13.039 17.4268 10.9233C17.4268 8.09039 15.4187 6.54847 12.7053 6.54847C9.54968 6.54847 7.11123 8.81957 7.11123 12.023C7.11123 13.5649 8.05553 14.3538 8.05553 14.7244C8.05553 15.0352 7.82842 16.1349 7.43395 16.1349C6.4777 16.1349 4.8999 14.5411 4.8999 11.7361C4.8999 7.32543 8.94007 4.6001 13.028 4.6001Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.cf8c864082998a44ea85b2b71bfb4f77.svg";
export { ForwardRef as ReactComponent };